if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        // The script is loaded async, so when the element is defined before the parser
        // reaches it the constructor runs before its children exist: querySelector('form')
        // returned null, no submit listener was bound and the native POST to /cart/add
        // redirected to the cart page instead of opening the drawer. Listen on the host
        // (submit bubbles) and look the form up lazily so the timing no longer matters.
        this.addEventListener('submit', (evt) => {
          if (evt.target !== this.form) return;
          this.onSubmitHandler(evt);
        });

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        this.cart = this.cart || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.enableIdInput();
        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');
      }

      get form() {
        return this.querySelector('form');
      }

      enableIdInput() {
        const idInput = this.form?.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
      }

      // AT1-596: looked up on demand instead of cached in the constructor. The PDP
      // CTA can render as a type="button" ("Select size" or waitlist) and only
      // becomes type="submit" after a size is picked, so a cached lookup would be null.
      get submitButton() {
        return this.querySelector('[type="submit"]');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        // AT1-596: never add to cart while no size has been picked.
        if (this.querySelector('.product-form__submit--select-size')) return;
        if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton?.setAttribute('aria-disabled', true);
        this.submitButton?.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');
        
        const cartDrawerCTLAdded = document.querySelector('#CartDrawer.cart-drawer--ctl-product-added');
        if (cartDrawerCTLAdded) {
          localStorage.removeItem('isCartUpSell');
          cartDrawerCTLAdded.classList.remove('cart-drawer--ctl-product-added');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        this.cart = this.cart || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.enableIdInput();
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              setTimeout(() => {
                this.cart.renderContents(response);
              }, 300);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        console.log('errorMessage',errorMessage)

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          if (errorMessage.includes('Required parameter missing or')) {
            errorMessage = 'Please select your size';
          }
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
